export const searchCardDefaultInputs = [
    {
        key: "approvalPhase",
        label: "승인",
        type: "auto",
        col: "12",
        sm: "4",
        lg: "2",
        value: "All",
        list: ["All", "미확인", "미승인", "승인", "반려"],
    },
    {
        key: "inhouseBidNumber",
        label: "사내 견적번호",
        col: "12",
        sm: "4",
        lg: "2",
        value: "",
    },
    {
        key: "companyBidNumber",
        label: "기업별 입찰번호",
        col: "12",
        sm: "4",
        lg: "2",
        value: "",
    },
    {
        key: "companyName",
        label: "업체명",
        col: "12",
        sm: "4",
        lg: "2",
        value: "",
    },
    {
        key: "createdTime",
        label: "발행일",
        type: "dateRange",
        range: true,
        value: [],
        col: "12",
        sm: "4",
        lg: "2",
    },
];
export const estimate_approve_headers = [
    { text: "No.", align: "start", value: "id" },
    { text: "승인 단계", align: "start", value: "approvalPhase" },
    { text: "신청자", align: "start", value: "createrName" },
    { text: "확인자", align: "start", value: "checkerName" },
    { text: "승인자", align: "start", value: "approverName" },
    { text: "발행일", align: "start", value: "createdTime" },
    { text: "업체명", align: "start", value: "companyName" },
    {
        text: "사내 견적번호",
        align: "start",
        value: "inhouseBidNumber",
    },
    {
        text: "기업별 입찰번호",
        align: "start",
        value: "companyBidNumber",
    },
    { text: "총액", align: "start", value: "totalPrice" },
];
